import { IApplicationState } from '../../types/redux';

export const mortgageSeoPageUrlSelector = (state: IApplicationState): string => {
  return `${state.newbuilding.fullUrl}ipoteka-zhk/`;
};
